/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import helperMarkdownToComponent from 'helpers/Data';
import style from './Metadata.module.scss';

const linkableGenres = [
  'biography',
  'comedy',
  'crime',
  'faith',
  'history',
  'holiday',
  'listen',
  'live',
  'movies',
  'nature',
  'news',
  'opinion',
  'personalities',
  'politics',
  'reality',
  'series',
  'war',
];

const Metadata = ({ airDateInfo, genres, ratingInfo, seasonInfo, theme }) => {
  const processedGenres = genres.map(genre => {
    if (linkableGenres.includes(genre.toLowerCase())) {
      return `[${genre}](/browse/${genre?.toLowerCase()}/)`;
    }
    return genre;
  });

  const metaData = `${airDateInfo} ${seasonInfo} ${processedGenres.join(', ')} ${ratingInfo}`;
  const MetaData = helperMarkdownToComponent(metaData, () => {}, {
    Paragraph: props => {
      const { children } = props;
      if (!children) return null;
      return <span className={classNames(style.metaData, theme.metaData)}>{children}</span>;
    },
    Link: props => (
      <Link to={props.href} className={style.genreLink}>
        {props.children}
      </Link>
    ),
  });
  return <div className={style.metaData}>{MetaData}</div>;
};

Metadata.propTypes = {
  airDateInfo: PropTypes.string,
  genres: PropTypes.arrayOf(PropTypes.string),
  ratingInfo: PropTypes.string,
  seasonInfo: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default Metadata;
